import { Outlet } from 'react-router-dom';
import './App.css';
import Layout from './layout/Layout';
import ScrollToTop from './methods/scrollTo/ScrollToTop';

function App() {
  return (
    <div className=" min-h-screen py-4">
      <ScrollToTop />
      <Layout>
        <Outlet />
      </Layout>
    </div>
  );
}

export default App;
